import React, { Component } from 'react';

import styles from './styles';

class InputExpanding extends Component {
  constructor(props) {
    super(props);
    this.focus = this.focus.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClipAtMaxLength = this.handleClipAtMaxLength.bind(this);
    this.handlePasteOnlyPlaintext = this.handlePasteOnlyPlaintext.bind(this);
    this._input = {
      focus: () => {},
      blur: () => {},
    };
  }

  shouldComponentUpdate(nextProps) {
    const currentValue = this.props.value;
    const nextValue = nextProps.value;
    const contentValue = this._input.innerHTML;
    const placeholder = this.props.placeholder;
    const nextPlaceholder = nextProps.placeholder;

    // Don't re-render when the content is the same because it would make the cursor jump
    const nextValueEqualsContent = nextValue === contentValue;
    const nextValueEqualsValue = nextValue === currentValue;
    const nextPlaceholderSame = placeholder === nextPlaceholder;

    const nextValueSame = (nextValueEqualsContent || nextValueEqualsValue) && nextPlaceholderSame;

    return !nextValueSame;
  }

  componentDidUpdate() {
    const { value } = this.props;

    const htmlIsOutOfDate = this._input && value !== this._input.innerHTML;
    if (htmlIsOutOfDate) {
      this._input.innerHTML = this.props.value;
    }
  }

  focus() {
    if (this._input) this._input.focus();
  }

  blur() {
    if (this._input) this._input.blur();
  }

  handleKeyPress(e) {
    this.props.onKeyPress(e);
  }

  handleChange() {
    const { onChange } = this.props;

    const currentInputValue = this._input.innerHTML;
    const inputValuesChanged = currentInputValue !== this._lastHtml;
    if (onChange && inputValuesChanged) {
      onChange({
        target: {
          value: currentInputValue,
        },
      });
    }
    this._lastHtml = currentInputValue;
  }

  handleClipAtMaxLength(e) {
    const { maxlength } = this.props;

    const isAllowedKey = e.key === 'Backspace' || e.key === 'Enter';
    const isControlKey = e.altKey || e.metaKey || e.ctrlKey || e.shiftKey;
    if (this._input.innerText.length === maxlength && !isAllowedKey && !isControlKey) {
      e.preventDefault();
    }
  }

  handlePasteOnlyPlaintext(e) {
    const { maxlength } = this.props;

    e.preventDefault();
    const plaintext = e.clipboardData.getData('text/plain') || '';

    const maxlengthWithContent = maxlength - this._input.innerHTML.length;
    const plaintextClipped = plaintext.substr(0, maxlengthWithContent);
    document.execCommand('insertHTML', false, plaintextClipped);
  }

  render() {
    const { placeholder, value } = this.props;
    const html = { __html: value || null };
    return (
      <div
        key="input"
        role="textbox"
        className="messageInput kustomer-app-reply-input"
        style={styles.input}
        ref={c => {
          this._input = c;
        }}
        placeholder={placeholder}
        contentEditable
        onKeyPress={this.handleKeyPress}
        onKeyDown={this.handleClipAtMaxLength}
        onInput={this.handleChange}
        onBlur={this.handleChange}
        onPaste={this.handlePasteOnlyPlaintext}
        dangerouslySetInnerHTML={html} // eslint-disable-line react/no-danger
      />
    );
  }
}

InputExpanding.propTypes = {
  placeholder: React.PropTypes.string,
  onKeyPress: React.PropTypes.func,
  onChange: React.PropTypes.func,
  value: React.PropTypes.string,
  maxlength: React.PropTypes.number,
};
InputExpanding.defaultProps = {
  placeholder: '',
  onKeyPress: () => {},
  onChange: () => {},
  value: '',
  maxlength: 10240,
};

export default InputExpanding;
